import { z } from "zod";
import { StableUuidSchema } from "./identifiers.js";
/** A scoped source refresh is synchronous and succeeds only after durable completion. */
export const OpenProjectScopedRefreshResultSchema = z.object({
    accepted: z.literal(true),
    completed: z.literal(true),
    sourceRunId: StableUuidSchema,
});
export const OpenProjectRosterPersonSchema = z
    .object({
    openProjectUserId: z.number().int().positive().safe(),
    username: z.string().min(1).max(200),
    displayName: z.string().min(1).max(200),
    email: z.string().max(320),
    active: z.boolean(),
})
    .strict();
export const OpenProjectRosterPreviewSchema = z
    .object({
    checksum: z.string().regex(/^[a-f0-9]{64}$/),
    people: z.array(OpenProjectRosterPersonSchema).max(10_000),
    added: z.number().int().nonnegative(),
    retained: z.number().int().nonnegative(),
    archived: z.number().int().nonnegative(),
})
    .strict();
export const OpenProjectRosterStatusSchema = z
    .object({
    checksum: z.string().regex(/^[a-f0-9]{64}$/),
    included: z.number().int().nonnegative(),
    reviewed: z.boolean(),
})
    .strict();
export const OpenProjectRosterCandidatesSchema = z
    .object({ people: z.array(OpenProjectRosterPersonSchema).max(100_000) })
    .strict();
//# sourceMappingURL=openproject.js.map